/**
 * Task Import Vuex Store Module
 * State management for the task import/export feature.
 *
 * Key features:
 * - Import tasks to existing TaskBoard or create new
 * - Export tasks to CSV
 * - Field mapping between Excel columns and task fields
 * - Duplicate detection with auto-overwrite
 * - Mutually exclusive Facility/FacilityGroup linking (ForgeBaseTag pattern)
 */

import state from './state';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';

export const TASK_IMPORT = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default TASK_IMPORT;
